// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/Gambarino-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/Gambarino-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Gambarino";
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}

/* Make the wrapper not affect typography/layout selectors */
.scrollWipeGroup {
  display: contents;
}

.hero {
  width: 100%;
  box-sizing: border-box;
  padding: 72px 0 0;
}

.hero__inner {
  --railW: min(90vw);
  --textW: min(67.5vw);
  --gutter: calc((100% - var(--railW)) / 2);
  --edgeGap: clamp(26px, 3.2vw, 44px);
  --paraGap: clamp(22px, 2.8vw, 40px);

  padding: 0 clamp(16px, 3vw, 56px);
  padding-bottom: 220px;
  box-sizing: border-box;
  overflow: visible;
}

.hero__title,
.hero__conclusion {
  width: 85vw;
  margin: 0 auto;
  text-align: center;
  white-space: nowrap;
  line-height: 0.98;
  padding-bottom: 0.06em;
  font-weight: 800;
}

.hero__title {
  width: 90vw;
  margin: 0 auto var(--edgeGap);
  text-align: center;
  white-space: nowrap;
  line-height: 0.98;
  padding-bottom: 0.06em;
  font-weight: 800;
  font-size: clamp(56px, 5vw, 104px);
}

/* BODY COPY (LEFT-ALIGNED blocks) */
.hero__lede {
  width: var(--textW);
  margin: 0 auto;
  margin-left: var(--gutter);
  text-align: left;
  font-weight: 400;
  line-height: 1.55;
  font-size: clamp(18px, 1.45vw, 24px);
  color: rgba(0, 0, 0, 0.86);
  font-family: Gambarino, serif;
}

/* BODY COPY (RIGHT-ALIGNED blocks) */
.hero__rede {
  width: var(--textW);
  margin: 0 auto;
  margin-right: var(--gutter);
  text-align: right;
  font-weight: 400;
  line-height: 1.55;
  font-size: clamp(18px, 1.45vw, 24px);
  color: rgba(0, 0, 0, 0.86);
  font-family: Gambarino, serif;
}

.manifestoProblems {
  width: 100%;
  margin: 96px 0;
  color: #111111;
}

.manifestoProblems__intro {
  margin: 0 0 18px;
  font-family: Geist, Helvetica, Arial, sans-serif;
  font-size: 24px;
  line-height: 1.2;
  font-weight: 500;
  color: rgba(17, 17, 17, 0.86);
}

.manifestoProblems__title {
  margin: 0 0 36px;
  max-width: 36ch;
  font-family: Geist, Helvetica, Arial, sans-serif;
  font-size: clamp(36px, 5vw, 72px);
  line-height: 0.96;
  font-weight: 700;
  letter-spacing: -0.05em;
  color: #111111;
}

.manifestoProblems__list {
  border-top: 1px solid rgba(17, 17, 17, 0.34);
}

.manifestoProblemRow {
  display: grid;
  grid-template-columns: 64px minmax(0, 1fr);
  gap: 22px;
  align-items: start;
  padding: 26px 0 30px;
  border-bottom: 1px solid rgba(17, 17, 17, 0.34);
}

.manifestoProblemRow__num {
  font-family: Geist, Helvetica, Arial, sans-serif;
  font-size: clamp(42px, 4vw, 64px);
  line-height: 0.9;
  font-weight: 700;
  letter-spacing: -0.05em;
  color: rgba(17, 17, 17, 0.9);
}

.manifestoProblemRow__content {
  min-width: 0;
}

.manifestoProblemRow__headline {
  margin: 0;
  max-width: 56ch;
  font-family: Geist, Helvetica, Arial, sans-serif;
  font-size: clamp(34px, 4.8vw, 64px);
  line-height: 0.98;
  font-weight: 700;
  letter-spacing: -0.05em;
  color: #111111;
}

.manifestoProblemRow__body {
  margin: 14px 0 0;
  max-width: 62ch;
  font-family: Gambarino, Geist, Helvetica, Arial, sans-serif;
  font-size: clamp(17px, 1.5vw, 22px);
  line-height: 1.45;
  font-weight: 400;
  color: rgba(17, 17, 17, 0.74);
}

.manifestoProcess {
  width: 100%;
  margin: 110px 0 90px;
  color: #111111;
}

.manifestoProcess__eyebrow {
  margin: 0 0 14px;
  font-family: Geist, Helvetica, Arial, sans-serif;
  font-size: 14px;
  line-height: 1.2;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: rgba(17, 17, 17, 0.62);
}

.manifestoProcess__title {
  margin: 0 0 34px;
  max-width: 56ch;
  font-family: Geist, Helvetica, Arial, sans-serif;
  font-size: clamp(40px, 4vw, 74px);
  line-height: 0.95;
  font-weight: 700;
  letter-spacing: -0.05em;
  color: #111111;
}

.manifestoProcess__stack {
  display: grid;
  gap: 36px;
}

.manifestoStep {
  position: relative;
  padding: 32px 0;
  border-radius: 0;
  background: transparent;
  border: 0;
  box-shadow: none;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  overflow: visible;
}

.manifestoStep__meta {
  width: 100%;
  margin: 0 0 12px;
  font-family: Geist, Helvetica, Arial, sans-serif;
  font-size: 13px;
  line-height: 1.2;
  font-weight: 700;
  letter-spacing: 0.14em;
  color: rgba(17, 17, 17, 0.6);
}

.manifestoStep__title {
  width: 100%;
  margin: 0 0 18px;
  max-width: 18ch;
  font-family: Geist, Helvetica, Arial, sans-serif;
  font-size: clamp(30px, 3.4vw, 52px);
  line-height: 0.98;
  font-weight: 700;
  letter-spacing: -0.05em;
  color: #111111;
}

.manifestoStep__main {
  min-width: 0;
  width: 100%;
}

/* A / Borrowing: text on left, image on right, text aligned against image */
.manifestoStep--featured {
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(420px, 0.95fr);
  gap: 28px;
  align-items: center;
}

.manifestoStep--featured .manifestoStep__main {
  max-width: 720px;
  margin-left: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
}

.manifestoStep--featured .manifestoStep__meta,
.manifestoStep--featured .manifestoStep__title,
.manifestoStep--featured .manifestoStep__listRight,
.manifestoStep--featured .manifestoStep__body {
  width: 100%;
  max-width: 680px;
}

/* B / Lending: image on left, text on right */
.manifestoStep--splitLeft {
  display: grid;
  grid-template-columns: minmax(420px, 0.95fr) minmax(0, 1.05fr);
  gap: 36px;
  align-items: center;
}

.manifestoStep--splitLeft .manifestoStep__media {
  grid-column: 1;
  width: 100%;
}

.manifestoStep--splitLeft .manifestoStep__main {
  grid-column: 2;
  min-width: 0;
  width: 100%;
  max-width: none;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}

.manifestoStep--splitLeft .manifestoStep__meta,
.manifestoStep--splitLeft .manifestoStep__title,
.manifestoStep--splitLeft .manifestoStep__body,
.manifestoStep--splitLeft .manifestoStep__listLeft {
  width: 100%;
  max-width: none;
}

/* Generic side-by-side variant if you use it elsewhere */
.manifestoStep--split {
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(320px, 0.95fr);
  gap: 36px;
  align-items: center;
}

.manifestoStep__listRight {
  margin: 0;
  padding-left: 0;
  padding-right: 0;
  display: grid;
  gap: 12px;
  line-height: 1.5;
  list-style: none;
}

.manifestoStep__listRight li {
  text-align: right;
  font-family: Gambarino, Helvetica, Arial, sans-serif;
  font-size: clamp(17px, 1.35vw, 22px);
  line-height: 1.5;
  font-weight: 200;
  color: rgba(17, 17, 17, 0.82);
}

.manifestoStep__listLeft {
  margin: 0;
  padding-left: 0;
  padding-right: 0;
  line-height: 1.5;
  display: grid;
  gap: 12px;
  list-style: none;
}

.manifestoStep__listLeft li {
  text-align: left;
  font-family: Gambarino, Helvetica, Arial, sans-serif;
  font-size: clamp(17px, 1.35vw, 22px);
  line-height: 1.5;
  font-weight: 400;
  color: rgba(17, 17, 17, 0.82);
}

.manifestoStep__body {
  display: grid;
  gap: 12px;
  max-width: 900px;
}

.manifestoStep__body p {
  text-align: left;
  font-family: Gambarino, Helvetica, Arial, sans-serif;
  font-size: clamp(17px, 1.35vw, 22px);
  line-height: 1.5;
  font-weight: 200;
  color: rgba(17, 17, 17, 0.82);
}

.manifestoStep__media {
  position: relative;
  width: 100%;
  min-height: 100%;
  border-radius: 22px;
  overflow: hidden;
  background: transparent;
  border: 0;
}

.manifestoStep__image {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 420px;
  object-fit: cover;
  border-radius: 22px;
}

/* BOTTOMLINE */
.hero__conclusion {
  width: var(--railW);
  margin: 0 auto;
  text-align: center;
  font-weight: 800;
  line-height: 0.98;
  padding-bottom: 0.06em;
  overflow: visible;
  font-size: clamp(56px, 5vw, 104px);
  white-space: nowrap;
}

/* spacing */
.hero__title + .hero__lede,
.hero__title + .hero__rede {
  margin-top: var(--edgeGap);
}

.hero__lede + .hero__rede {
  margin-top: var(--paraGap);
}

.hero__rede + .hero__lede {
  margin-top: var(--paraGap);
}

.hero__lede + .hero__conclusion,
.hero__rede + .hero__conclusion {
  margin-top: var(--edgeGap);
}

/* WIPE */
.cw-wipe {
  --p: 0;
  --n: 1;
  --dim: rgba(0, 0, 0, 0.26);
  --ink: rgba(0, 0, 0, 0.92);

  position: relative;
}

.cw-wipe .cw-char {
  position: relative;
  display: inline-block;
  white-space: pre;
}

.cw-wipe .cw-dim {
  color: var(--dim);
}

.cw-wipe .cw-ink {
  position: absolute;
  inset: 0;
  color: var(--ink);
  opacity: clamp(0, calc((var(--p) * var(--n)) - var(--i)), 1);
  transition: opacity 60ms linear;
}

.cw-wipe,
.cw-wipe * {
  -webkit-font-smoothing: antialiased;
}

.cw-word {
  white-space: nowrap;
}

.cw-space {
  white-space: pre-wrap;
}

.cw-char {
  display: inline-block;
}

@media (max-width: 980px) {
  .manifestoStep--featured,
  .manifestoStep--splitLeft,
  .manifestoStep--split {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .manifestoStep--featured .manifestoStep__main,
  .manifestoStep--splitLeft .manifestoStep__main {
    max-width: none;
    margin-left: 0;
    align-items: flex-start;
    text-align: left;
  }

  .manifestoStep--featured .manifestoStep__meta,
  .manifestoStep--featured .manifestoStep__title,
  .manifestoStep--featured .manifestoStep__listRight,
  .manifestoStep--featured .manifestoStep__body,
  .manifestoStep--splitLeft .manifestoStep__meta,
  .manifestoStep--splitLeft .manifestoStep__title,
  .manifestoStep--splitLeft .manifestoStep__body,
  .manifestoStep--splitLeft .manifestoStep__listLeft {
    max-width: none;
  }

  .manifestoStep--splitLeft .manifestoStep__media,
  .manifestoStep--splitLeft .manifestoStep__main {
    grid-column: auto;
  }

  .manifestoStep__listRight li {
    text-align: left;
  }

  .manifestoStep__image {
    min-height: 280px;
  }
}

@media (max-width: 900px) {
  .manifestoProblems {
    margin: 72px 0;
  }

  .manifestoProblemRow {
    grid-template-columns: 1fr;
    gap: 10px;
    padding: 22px 0 24px;
  }

  .manifestoProblemRow__headline,
  .manifestoProblemRow__body {
    max-width: none;
  }
}

@media (max-width: 720px) {
  .manifestoProcess {
    margin: 72px 0 64px;
  }

  .manifestoStep {
    padding: 22px 0;
  }

  .manifestoStep__title {
    max-width: none;
  }
}

/* Mobile: drop the left/right snapping, make it readable */
@media (max-width: 768px) {
  .hero {
    padding: 56px 0 64px;
  }

  .hero__inner {
    --railW: 92vw;
    --textW: 92vw;
    padding: 0 20px;
  }

  .hero__title,
  .hero__conclusion {
    white-space: normal;
    font-size: clamp(42px, 10vw, 64px);
    line-height: 0.98;
  }

  .hero__lede,
  .hero__rede {
    margin-left: auto;
    margin-right: auto;
    text-align: left;
    font-size: clamp(17px, 4.6vw, 21px);
    line-height: 1.6;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/fullmanifesto.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB;;8DAEiE;EACjE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,4DAA4D;AAC5D;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,yCAAyC;EACzC,mCAAmC;EACnC,mCAAmC;;EAEnC,iCAAiC;EACjC,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;EACnB,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA,qCAAqC;AACrC;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE,gDAAgD;EAChD,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gDAAgD;EAChD,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,2DAA2D;EAC3D,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,qBAAqB;EACrB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,8DAA8D;EAC9D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;;;;EAIE,WAAW;EACX,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,8DAA8D;EAC9D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,eAAe;EACf,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;;;EAIE,WAAW;EACX,eAAe;AACjB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,8DAA8D;EAC9D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oDAAoD;EACpD,oCAAoC;EACpC,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oDAAoD;EACpD,oCAAoC;EACpC,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oDAAoD;EACpD,oCAAoC;EACpC,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA,YAAY;AACZ;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA,SAAS;AACT;EACE,MAAM;EACN,MAAM;EACN,0BAA0B;EAC1B,0BAA0B;;EAE1B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,4DAA4D;EAC5D,+BAA+B;AACjC;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;;;IAGE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;;IAEE,eAAe;IACf,cAAc;IACd,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;;;;;;;;IAQE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,oBAAoB;EACtB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,2DAA2D;AAC3D;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,aAAa;IACb,eAAe;EACjB;;EAEA;;IAEE,mBAAmB;IACnB,kCAAkC;IAClC,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mCAAmC;IACnC,gBAAgB;EAClB;AACF","sourcesContent":["@font-face {\n  font-family: \"Gambarino\";\n  src:\n    url(\"../assets/fonts/Gambarino-Regular.woff2\") format(\"woff2\"),\n    url(\"../assets/fonts/Gambarino-Regular.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n/* Make the wrapper not affect typography/layout selectors */\n.scrollWipeGroup {\n  display: contents;\n}\n\n.hero {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 72px 0 0;\n}\n\n.hero__inner {\n  --railW: min(90vw);\n  --textW: min(67.5vw);\n  --gutter: calc((100% - var(--railW)) / 2);\n  --edgeGap: clamp(26px, 3.2vw, 44px);\n  --paraGap: clamp(22px, 2.8vw, 40px);\n\n  padding: 0 clamp(16px, 3vw, 56px);\n  padding-bottom: 220px;\n  box-sizing: border-box;\n  overflow: visible;\n}\n\n.hero__title,\n.hero__conclusion {\n  width: 85vw;\n  margin: 0 auto;\n  text-align: center;\n  white-space: nowrap;\n  line-height: 0.98;\n  padding-bottom: 0.06em;\n  font-weight: 800;\n}\n\n.hero__title {\n  width: 90vw;\n  margin: 0 auto var(--edgeGap);\n  text-align: center;\n  white-space: nowrap;\n  line-height: 0.98;\n  padding-bottom: 0.06em;\n  font-weight: 800;\n  font-size: clamp(56px, 5vw, 104px);\n}\n\n/* BODY COPY (LEFT-ALIGNED blocks) */\n.hero__lede {\n  width: var(--textW);\n  margin: 0 auto;\n  margin-left: var(--gutter);\n  text-align: left;\n  font-weight: 400;\n  line-height: 1.55;\n  font-size: clamp(18px, 1.45vw, 24px);\n  color: rgba(0, 0, 0, 0.86);\n  font-family: Gambarino, serif;\n}\n\n/* BODY COPY (RIGHT-ALIGNED blocks) */\n.hero__rede {\n  width: var(--textW);\n  margin: 0 auto;\n  margin-right: var(--gutter);\n  text-align: right;\n  font-weight: 400;\n  line-height: 1.55;\n  font-size: clamp(18px, 1.45vw, 24px);\n  color: rgba(0, 0, 0, 0.86);\n  font-family: Gambarino, serif;\n}\n\n.manifestoProblems {\n  width: 100%;\n  margin: 96px 0;\n  color: #111111;\n}\n\n.manifestoProblems__intro {\n  margin: 0 0 18px;\n  font-family: Geist, Helvetica, Arial, sans-serif;\n  font-size: 24px;\n  line-height: 1.2;\n  font-weight: 500;\n  color: rgba(17, 17, 17, 0.86);\n}\n\n.manifestoProblems__title {\n  margin: 0 0 36px;\n  max-width: 36ch;\n  font-family: Geist, Helvetica, Arial, sans-serif;\n  font-size: clamp(36px, 5vw, 72px);\n  line-height: 0.96;\n  font-weight: 700;\n  letter-spacing: -0.05em;\n  color: #111111;\n}\n\n.manifestoProblems__list {\n  border-top: 1px solid rgba(17, 17, 17, 0.34);\n}\n\n.manifestoProblemRow {\n  display: grid;\n  grid-template-columns: 64px minmax(0, 1fr);\n  gap: 22px;\n  align-items: start;\n  padding: 26px 0 30px;\n  border-bottom: 1px solid rgba(17, 17, 17, 0.34);\n}\n\n.manifestoProblemRow__num {\n  font-family: Geist, Helvetica, Arial, sans-serif;\n  font-size: clamp(42px, 4vw, 64px);\n  line-height: 0.9;\n  font-weight: 700;\n  letter-spacing: -0.05em;\n  color: rgba(17, 17, 17, 0.9);\n}\n\n.manifestoProblemRow__content {\n  min-width: 0;\n}\n\n.manifestoProblemRow__headline {\n  margin: 0;\n  max-width: 56ch;\n  font-family: Geist, Helvetica, Arial, sans-serif;\n  font-size: clamp(34px, 4.8vw, 64px);\n  line-height: 0.98;\n  font-weight: 700;\n  letter-spacing: -0.05em;\n  color: #111111;\n}\n\n.manifestoProblemRow__body {\n  margin: 14px 0 0;\n  max-width: 62ch;\n  font-family: Gambarino, Geist, Helvetica, Arial, sans-serif;\n  font-size: clamp(17px, 1.5vw, 22px);\n  line-height: 1.45;\n  font-weight: 400;\n  color: rgba(17, 17, 17, 0.74);\n}\n\n.manifestoProcess {\n  width: 100%;\n  margin: 110px 0 90px;\n  color: #111111;\n}\n\n.manifestoProcess__eyebrow {\n  margin: 0 0 14px;\n  font-family: Geist, Helvetica, Arial, sans-serif;\n  font-size: 14px;\n  line-height: 1.2;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: rgba(17, 17, 17, 0.62);\n}\n\n.manifestoProcess__title {\n  margin: 0 0 34px;\n  max-width: 56ch;\n  font-family: Geist, Helvetica, Arial, sans-serif;\n  font-size: clamp(40px, 4vw, 74px);\n  line-height: 0.95;\n  font-weight: 700;\n  letter-spacing: -0.05em;\n  color: #111111;\n}\n\n.manifestoProcess__stack {\n  display: grid;\n  gap: 36px;\n}\n\n.manifestoStep {\n  position: relative;\n  padding: 32px 0;\n  border-radius: 0;\n  background: transparent;\n  border: 0;\n  box-shadow: none;\n  backdrop-filter: none;\n  -webkit-backdrop-filter: none;\n  overflow: visible;\n}\n\n.manifestoStep__meta {\n  width: 100%;\n  margin: 0 0 12px;\n  font-family: Geist, Helvetica, Arial, sans-serif;\n  font-size: 13px;\n  line-height: 1.2;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  color: rgba(17, 17, 17, 0.6);\n}\n\n.manifestoStep__title {\n  width: 100%;\n  margin: 0 0 18px;\n  max-width: 18ch;\n  font-family: Geist, Helvetica, Arial, sans-serif;\n  font-size: clamp(30px, 3.4vw, 52px);\n  line-height: 0.98;\n  font-weight: 700;\n  letter-spacing: -0.05em;\n  color: #111111;\n}\n\n.manifestoStep__main {\n  min-width: 0;\n  width: 100%;\n}\n\n/* A / Borrowing: text on left, image on right, text aligned against image */\n.manifestoStep--featured {\n  display: grid;\n  grid-template-columns: minmax(0, 1.05fr) minmax(420px, 0.95fr);\n  gap: 28px;\n  align-items: center;\n}\n\n.manifestoStep--featured .manifestoStep__main {\n  max-width: 720px;\n  margin-left: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  text-align: right;\n}\n\n.manifestoStep--featured .manifestoStep__meta,\n.manifestoStep--featured .manifestoStep__title,\n.manifestoStep--featured .manifestoStep__listRight,\n.manifestoStep--featured .manifestoStep__body {\n  width: 100%;\n  max-width: 680px;\n}\n\n/* B / Lending: image on left, text on right */\n.manifestoStep--splitLeft {\n  display: grid;\n  grid-template-columns: minmax(420px, 0.95fr) minmax(0, 1.05fr);\n  gap: 36px;\n  align-items: center;\n}\n\n.manifestoStep--splitLeft .manifestoStep__media {\n  grid-column: 1;\n  width: 100%;\n}\n\n.manifestoStep--splitLeft .manifestoStep__main {\n  grid-column: 2;\n  min-width: 0;\n  width: 100%;\n  max-width: none;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  text-align: left;\n}\n\n.manifestoStep--splitLeft .manifestoStep__meta,\n.manifestoStep--splitLeft .manifestoStep__title,\n.manifestoStep--splitLeft .manifestoStep__body,\n.manifestoStep--splitLeft .manifestoStep__listLeft {\n  width: 100%;\n  max-width: none;\n}\n\n/* Generic side-by-side variant if you use it elsewhere */\n.manifestoStep--split {\n  display: grid;\n  grid-template-columns: minmax(0, 1.05fr) minmax(320px, 0.95fr);\n  gap: 36px;\n  align-items: center;\n}\n\n.manifestoStep__listRight {\n  margin: 0;\n  padding-left: 0;\n  padding-right: 0;\n  display: grid;\n  gap: 12px;\n  line-height: 1.5;\n  list-style: none;\n}\n\n.manifestoStep__listRight li {\n  text-align: right;\n  font-family: Gambarino, Helvetica, Arial, sans-serif;\n  font-size: clamp(17px, 1.35vw, 22px);\n  line-height: 1.5;\n  font-weight: 200;\n  color: rgba(17, 17, 17, 0.82);\n}\n\n.manifestoStep__listLeft {\n  margin: 0;\n  padding-left: 0;\n  padding-right: 0;\n  line-height: 1.5;\n  display: grid;\n  gap: 12px;\n  list-style: none;\n}\n\n.manifestoStep__listLeft li {\n  text-align: left;\n  font-family: Gambarino, Helvetica, Arial, sans-serif;\n  font-size: clamp(17px, 1.35vw, 22px);\n  line-height: 1.5;\n  font-weight: 400;\n  color: rgba(17, 17, 17, 0.82);\n}\n\n.manifestoStep__body {\n  display: grid;\n  gap: 12px;\n  max-width: 900px;\n}\n\n.manifestoStep__body p {\n  text-align: left;\n  font-family: Gambarino, Helvetica, Arial, sans-serif;\n  font-size: clamp(17px, 1.35vw, 22px);\n  line-height: 1.5;\n  font-weight: 200;\n  color: rgba(17, 17, 17, 0.82);\n}\n\n.manifestoStep__media {\n  position: relative;\n  width: 100%;\n  min-height: 100%;\n  border-radius: 22px;\n  overflow: hidden;\n  background: transparent;\n  border: 0;\n}\n\n.manifestoStep__image {\n  display: block;\n  width: 100%;\n  height: 100%;\n  min-height: 420px;\n  object-fit: cover;\n  border-radius: 22px;\n}\n\n/* BOTTOMLINE */\n.hero__conclusion {\n  width: var(--railW);\n  margin: 0 auto;\n  text-align: center;\n  font-weight: 800;\n  line-height: 0.98;\n  padding-bottom: 0.06em;\n  overflow: visible;\n  font-size: clamp(56px, 5vw, 104px);\n  white-space: nowrap;\n}\n\n/* spacing */\n.hero__title + .hero__lede,\n.hero__title + .hero__rede {\n  margin-top: var(--edgeGap);\n}\n\n.hero__lede + .hero__rede {\n  margin-top: var(--paraGap);\n}\n\n.hero__rede + .hero__lede {\n  margin-top: var(--paraGap);\n}\n\n.hero__lede + .hero__conclusion,\n.hero__rede + .hero__conclusion {\n  margin-top: var(--edgeGap);\n}\n\n/* WIPE */\n.cw-wipe {\n  --p: 0;\n  --n: 1;\n  --dim: rgba(0, 0, 0, 0.26);\n  --ink: rgba(0, 0, 0, 0.92);\n\n  position: relative;\n}\n\n.cw-wipe .cw-char {\n  position: relative;\n  display: inline-block;\n  white-space: pre;\n}\n\n.cw-wipe .cw-dim {\n  color: var(--dim);\n}\n\n.cw-wipe .cw-ink {\n  position: absolute;\n  inset: 0;\n  color: var(--ink);\n  opacity: clamp(0, calc((var(--p) * var(--n)) - var(--i)), 1);\n  transition: opacity 60ms linear;\n}\n\n.cw-wipe,\n.cw-wipe * {\n  -webkit-font-smoothing: antialiased;\n}\n\n.cw-word {\n  white-space: nowrap;\n}\n\n.cw-space {\n  white-space: pre-wrap;\n}\n\n.cw-char {\n  display: inline-block;\n}\n\n@media (max-width: 980px) {\n  .manifestoStep--featured,\n  .manifestoStep--splitLeft,\n  .manifestoStep--split {\n    grid-template-columns: 1fr;\n    gap: 24px;\n  }\n\n  .manifestoStep--featured .manifestoStep__main,\n  .manifestoStep--splitLeft .manifestoStep__main {\n    max-width: none;\n    margin-left: 0;\n    align-items: flex-start;\n    text-align: left;\n  }\n\n  .manifestoStep--featured .manifestoStep__meta,\n  .manifestoStep--featured .manifestoStep__title,\n  .manifestoStep--featured .manifestoStep__listRight,\n  .manifestoStep--featured .manifestoStep__body,\n  .manifestoStep--splitLeft .manifestoStep__meta,\n  .manifestoStep--splitLeft .manifestoStep__title,\n  .manifestoStep--splitLeft .manifestoStep__body,\n  .manifestoStep--splitLeft .manifestoStep__listLeft {\n    max-width: none;\n  }\n\n  .manifestoStep--splitLeft .manifestoStep__media,\n  .manifestoStep--splitLeft .manifestoStep__main {\n    grid-column: auto;\n  }\n\n  .manifestoStep__listRight li {\n    text-align: left;\n  }\n\n  .manifestoStep__image {\n    min-height: 280px;\n  }\n}\n\n@media (max-width: 900px) {\n  .manifestoProblems {\n    margin: 72px 0;\n  }\n\n  .manifestoProblemRow {\n    grid-template-columns: 1fr;\n    gap: 10px;\n    padding: 22px 0 24px;\n  }\n\n  .manifestoProblemRow__headline,\n  .manifestoProblemRow__body {\n    max-width: none;\n  }\n}\n\n@media (max-width: 720px) {\n  .manifestoProcess {\n    margin: 72px 0 64px;\n  }\n\n  .manifestoStep {\n    padding: 22px 0;\n  }\n\n  .manifestoStep__title {\n    max-width: none;\n  }\n}\n\n/* Mobile: drop the left/right snapping, make it readable */\n@media (max-width: 768px) {\n  .hero {\n    padding: 56px 0 64px;\n  }\n\n  .hero__inner {\n    --railW: 92vw;\n    --textW: 92vw;\n    padding: 0 20px;\n  }\n\n  .hero__title,\n  .hero__conclusion {\n    white-space: normal;\n    font-size: clamp(42px, 10vw, 64px);\n    line-height: 0.98;\n  }\n\n  .hero__lede,\n  .hero__rede {\n    margin-left: auto;\n    margin-right: auto;\n    text-align: left;\n    font-size: clamp(17px, 4.6vw, 21px);\n    line-height: 1.6;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
